module.exports = __webpack_public_path__ + "static/img/4.acd716b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/icon/4.png
// module id = DZNw
// module chunks = 1